import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
import axios from "../../context/axios";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const RecentView = () => {
  const [recentViews, setRecentViews] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);

  //   useEffect(() => {
  //     const fetchRecentViews = async () => {
  //       try {
  //         const user = JSON.parse(localStorage.getItem("user"));
  //         if (!user) {
  //           setLoading(false);
  //           return;
  //         }
  //         const token = localStorage.getItem("token");
  //         const res = await axios.get(`/recent-views/${user._id}`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         });
  //         setRecentViews(res.data);
  //       } catch (error) {
  //         console.error("Failed to fetch recent views", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchRecentViews();
  //   }, []);

  useEffect(() => {
    const fetchRecentViews = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const token = localStorage.getItem("token");

        if (user && token) {
          // Logged-in user flow
          const res = await axios.get(`/recent-views/${user._id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setRecentViews(res.data);
        } else {
          // Guest user flow — fetch from cookie
          const getCookie = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(";").shift();
            return null;
          };

          const cookieValue = getCookie("recentViews");
          if (!cookieValue) {
            setRecentViews([]);
            return;
          }

          const decoded = decodeURIComponent(cookieValue);
          const packageIds = JSON.parse(decoded); // Array of package IDs

          if (!Array.isArray(packageIds) || packageIds.length === 0) {
            setRecentViews([]);
            return;
          }

          const res = await axios.post("/recent-views/guest", {
            packageIds,
          });

          // Map response to a structure similar to logged-in flow (for consistent UI)
          setRecentViews(res.data.map((pkg) => ({ packageId: pkg })));
        }
      } catch (error) {
        console.error("Failed to fetch recent views:", error);
        setRecentViews([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentViews();
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth * 0.8; // scroll 80% of container width
      if (direction === "left") {
        scrollRef.current.scrollTo({
          left: scrollLeft - scrollAmount,
          behavior: "smooth",
        });
      } else {
        scrollRef.current.scrollTo({
          left: scrollLeft + scrollAmount,
          behavior: "smooth",
        });
      }
    }
  };

  if (loading)
    return <p className="text-center py-8">Loading recent views...</p>;

  if (!loading && recentViews.length === 0) {
    return null;
  }

  return (
    // <div className="max-w-7xl mx-auto px-4 py-6">
    <div className="max-w-7xl mx-auto px-4 py-1 mb-10">

      {/* Updated title */}
      <h2 className="text-2xl font-semibold mb-6">
        Are you still interested in these packages?
      </h2>

      <div className="relative">
        {/* Left arrow */}
        {/* Left arrow */}
        <button
          onClick={() => scroll("left")}
          className="absolute top-1/2 -left-2 transform -translate-y-1/2 bg-white rounded-full shadow-md p-2 hover:bg-gray-100 z-10 hidden md:block"
          aria-label="Scroll left"
        >
          <FaChevronLeft />
        </button>
        {/* Scroll container with scrollbar hidden */}
        <div
          ref={scrollRef}
          className="flex space-x-6 overflow-x-auto scroll-smooth pb-2"
          style={{
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE 10+
            scrollBehavior: "smooth",
          }}
        >
          {/* Hide scrollbar for Chrome, Safari, Opera */}
          <style>
            {`
              .no-scrollbar::-webkit-scrollbar {
                display: none;
              }
            `}
          </style>

          <div className="no-scrollbar flex space-x-6">
            {recentViews.map(({ packageId }) => {
              const tour = packageId;
              if (!tour) return null;

              return (
                // <a
                //   key={tour._id}
                //   href={`/tours/${tour._id}`}
                //   className="min-w-[280px] bg-white rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 border border-gray-200 flex-shrink-0 flex flex-col"
                // >
                <a
                  key={tour._id}
                  href={`/tours/${tour._id}`}
                  className="w-[340px] h-[320px] bg-white rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 border border-gray-200 flex-shrink-0 flex flex-col overflow-hidden"
                >
                  <div className="relative w-full overflow-hidden rounded-t-lg">
                    {/* <img
                      src={tour.img || tour.image || ""}
                      alt={tour.title}
                      className="w-full object-cover transform hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                      style={{ maxHeight: "280px" }} // optional max height to keep cards uniform
                    /> */}
                    <img
                      src={tour.img || tour.image || ""}
                      alt={tour.title}
                      className="w-full h-[180px] object-cover transition-transform duration-300"
                    />
                  </div>

                  <div className="p-4 flex flex-col flex-grow">
                    <h3 className="text-lg font-semibold mb-2 truncate">
                      {tour.title}
                    </h3>

                    <div className="flex flex-wrap text-gray-600 text-sm gap-3 mb-3">
                      <div className="flex items-center">
                        <span className="font-medium mr-1">Duration:</span>
                        <span>
                          {tour.duration
                            ? `${tour.duration.day}D / ${tour.duration.night}N`
                            : "N/A"}
                        </span>
                      </div>

                      {/* <div className="flex items-center">
                        <span className="font-medium mr-1">Region:</span>
                        <span>{tour.region}</span>
                      </div> */}
                    </div>

                    <div className="mt-auto flex items-center space-x-3">
                      {tour.originalPrice &&
                        tour.originalPrice > tour.price && (
                          <p className="text-sm text-gray-400 line-through">
                            €{tour.originalPrice.toLocaleString()}
                          </p>
                        )}
                      <p className="text-xl font-bold text-indigo-600">
                        €{tour.price?.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>

        {/* Right arrow */}
        <button
          onClick={() => scroll("right")}
          className="absolute top-1/2 -right-2 transform -translate-y-1/2 bg-white rounded-full shadow-md p-2 hover:bg-gray-100 z-10 hidden md:block"
          aria-label="Scroll right"
        >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default RecentView;
